const transactionHistoryText = [
     {accountType: "bank", 
        paragraph1: "This screen shows a breakdown of all the money you've deposited into or " +
                    "withdrawn from your savings account. Transactions are grouped by type, " +
                    "making it easy to see how your savings are growing and where your money is going.",
        paragraph2: "For Savings Accounts, you’ll see:",
        ulArr: [{label: "Deposits", text: "Money you’ve added to your savings."},
                {label: "Interest Earned", text: "Extra money the bank pays you for  " +
                    "keeping your savings with them."},
                {label: "Withdrawals", text: "Money you’ve taken out of your savings"},
                {label: "Withdrawal Fee", text: "A charge for taking money out of your savings " +
                    "account in a way that breaks the account’s rules."},
                {label: "Regular Tax", text: "Any taxes you’ve had to pay on interest earnings."}]
    },
    {accountType: "retirement", paragraph1: "", paragraph2: "", ulArr: []},
    {accountType: "investments", 
         paragraph1: "This screen gives you a summary of all the activity in your investment account" +
            "— including what you’ve bought, sold, and earned. Each transaction type is grouped so " +
            "you can track how your investments are performing and changing over time.",
        paragraph2: "For Investment Accounts, you’ll see:",
        ulArr: [{label: "Buy", text: "Money you spent to purchase investments like stocks or bonds."},
                {label: "Sell", text: "Money you received from selling investments."},
                {label: "Dividend", text: "Payments you get from owning stocks."},
                {label: "Coupon", text: "Payments you get from bonds (like interest)."},
                {label: "Buy-Sell", text: "A buy and sell of the same investment."},
                {label: "Regular Tax", text: "This applies to money you earn from your investments, " +
                    "like dividends or interest (coupon payments). It's treated like a paycheck and " +
                    "taxed at your income tax rate.  Regular tax amounts will also include taxes " +
                    "on profits where the investment was not held for at least a year."},
                {label: "Capital Gains Tax", text: "Taxes you pay when you make a profit from " +
                    "selling an investment. Tax amounts will only reflect profits that are made " +
                    "when the investment is held for at least 1 year before sold."}]
    },
                    
];
export default transactionHistoryText;